export default {
  en: {
    ColdCasesIndexScene: {
      title: 'Cold cases',
    },
  },
};
